export default "__VITE_ASSET__Bv2LhU4p__"